/**
 * Persistent pilot progression: total XP → level (cap 999).
 * XP is account-wide and survives runs/deaths. Level 1000 is reserved for
 * the "impossible" all-bosses gauntlet idea (docs/10).
 */
const STORAGE_KEY = 'bosshot-progress-v1';
export const MAX_LEVEL = 999;

export function loadTotalXp(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? Math.max(0, Number(JSON.parse(raw)) || 0) : 0;
  } catch {
    return 0;
  }
}

export function saveTotalXp(total: number): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Math.round(total)));
  } catch {
    /* storage unavailable — ignore */
  }
}

/** XP needed to go from level n to n+1 (grows linearly → level ~ sqrt(xp)) */
function costForLevel(n: number): number {
  return 100 + n * 22;
}

export function levelForXp(totalXp: number): number {
  let xp = totalXp;
  let level = 1;
  while (level < MAX_LEVEL) {
    const cost = costForLevel(level);
    if (xp < cost) break;
    xp -= cost;
    level++;
  }
  return level;
}
